// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6652923e","453":"65f0aa1b","455":"e4e103af","977":"a4cba8c8"}[chunkId] + ".chunk.js";
};